import React, {Component} from "react";
import {connect} from "react-redux";
import {reduxForm} from "redux-form/immutable";
import {submit} from "redux-form";
import ActionButton from "../../ActionButton";
import {cancelRemoveProduct, removeProduct} from "../../../actions/InventoryApiActions";
import {getSubmitInfoForCommand, getProductTypes} from "../../../reducers/inventoryReducer";
import {isSubmitting, submitLabel} from "../../../lib/CommandStatus";

class RemoveProductForm extends Component {

  render() {
    let {handleSubmit, submit, submitInfo} = this.props;
    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <p>Are you sure you want to remove this product?</p>
        </div>
        <div className="buttons">
          <ActionButton label={submitLabel(submitInfo, "Submit")} onClick={submit} active={!isSubmitting(submitInfo)} />
          <ActionButton label="Cancel" active={!isSubmitting(submitInfo)} onClick={this.props.cancelRemoveProduct} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "RemoveProductForm"
})(RemoveProductForm);

const ConnectedForm = connect(
  (state, ownProps) => ({
    submitInfo: getSubmitInfoForCommand(state.get("inventory"), "RemoveProduct"),
    productTypes: getProductTypes(state.get("inventory")),
    initialValues: {
      code: ownProps.code
    }
  }),
  {
    cancelRemoveProduct,
    submit,
    onSubmit: (data) => removeProduct(data, "RemoveProductForm")
  }
)(ReduxForm);

export default ConnectedForm;